module.exports = __webpack_public_path__ + "static/media/logo.1afe0f81.png";